import { AxiosResponse } from 'axios';

import { AdminRole, Affiliation } from '@/types/affiliation';
import { Organization } from '@/types/organization';
import { api } from '@/services/api/axios/instance';

type GetListParams = {
  data: {
    organizationId: Organization['id'];
  };
};

type InviteParams = {
  data: {
    organizationId: Organization['id'];
    email: string;
    role: AdminRole;
  };
};

export const affiliationsApi = {
  getAffiliationsOfOrganization: async (
    config: GetListParams,
  ): Promise<Affiliation[]> => {
    const { organizationId } = config.data;
    const path = `organizations/${organizationId}/affiliations`;

    const response: AxiosResponse<{
      affiliations: Affiliation[];
    }> = await api.get(path, config);

    return response.data.affiliations;
  },
  inviteToOrganization: async (
    config: InviteParams,
  ): Promise<Affiliation[]> => {
    const { organizationId, email, role } = config.data;
    const path = `organizations/${organizationId}/affiliations`;
    const params = {
      email: email.trim(),
      role,
    };

    const response: AxiosResponse<{
      affiliations: Affiliation[];
    }> = await api.post(path, params);

    return response.data.affiliations;
  },
  myOrganizations: async (): Promise<Affiliation[]> => {
    const path = `admins/me/affiliations`;
    const response: AxiosResponse<{ affiliations: Affiliation[] }> =
      await api.get(path, {});

    return response.data.affiliations;
  },
};
